import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between data-item-custom-route" }
const _hoisted_2 = { class: "font-medium font-weight-400" }
const _hoisted_3 = { class: "font-medium font-weight-400" }
const _hoisted_4 = { class: "d-flex justify-content-between data-item-custom-route" }
const _hoisted_5 = { class: "font-medium font-weight-400" }
const _hoisted_6 = { class: "font-medium font-weight-40" }
const _hoisted_7 = { class: "d-flex justify-content-between align-items-baseline data-item-custom-route" }
const _hoisted_8 = { class: "font-medium font-weight-700" }
const _hoisted_9 = { class: "font-medium font-weight-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('duration')), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.totalDuration.hours) + " " + _toDisplayString(_ctx.$t('shortened_hours')) + " " + _toDisplayString(_ctx.totalDuration.minutes) + " " + _toDisplayString(_ctx.$t('shortened_minutes')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('distance')), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.totalDistance) + " km. ", 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('price')), 1),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.price) + " € ", 1)
    ])
  ], 64))
}